<template>
  <div class="Profile">
    <AdvertisingModal
      :isOpened="showAdvertisingModal"
      @close="hideAdvertisingModal = true"
    />
    <WeDialog
      :isDisplay.sync="cguDialog"
      title="welcome.cguTitle"
      imgUrl=""
      :maxWidth="600"
      description="welcome.cguDescriptionMin"
    >
      <div class="cgu pa-6 d-flex flex-column align-center">
        <div class="title">
          {{ $t('welcome.cguTitle') }}
        </div>
        <div class="description mt-6">
          {{ $t('welcome.cguDescriptionMin') }}
        </div>
        <v-checkbox
          v-model="userConsent"
          :label="$t('welcome.cguCheckbox')"
          class="checkbox-dark cguCheckbox mt-7"
          elevation="0"
          color="#00D367"
          hide-details
        />
        <v-btn
          text
          class="theme-btn app-button-secondary color-white nice-padding mt-2 col-4"
          @click="cguDialog = false"
        >{{ $t('common.action.later') }}</v-btn>
      </div>
    </WeDialog>
    <div class="Drawer">
      <RightDrawer
        v-if="currentNodeId"
        :key="`id-${currentNodeId}`"
        class="Profile_rightDrawer"
        :person="selectedProfile"
        :style="`width: ${rightDrawerWidth}px;`"
        @close="selectCard(null)"
      />
    </div>
    <div class="mainContent">
      <a
        v-if="showAdvertising"
        class="mainContent_pub"
        :href="advertisingUrl"
        target="_blank"
      >
        <v-img
          class="mainContent_pub_image"
          :src="'./assets/images/advertising.png'"
        />
      </a>
      <div v-if="vous">
        <h1 class="header-title mb-8 mt-10">
          {{ $t('main.sections.your_profile') }}
        </h1>
        <v-row>
          <RelationCard
            :nodeState="vous.state"
            :firstName="vous.firstName"
            :lastName="vous.lastName"
            :sublabel="vous.sublabel"
            :lastUpdate="vous.lastUpdate"
            :type="vous.civility"
            :completion="vous.completion"
            :validationError="vous.validationError"
            @click="selectCard(vous.id)"
          />
        </v-row>
      </div>
      <div v-if="otherPeople.length > 0">
        <h1 class="header-title mb-8 mt-10">
          {{ $tc(`main.sections.${otherPeople[0] && otherPeople[0].type}`, peopleDetails.length) }}
          <div class="NbPersons">({{ peopleDetails.length }})</div>
        </h1>
        <v-row>
          <RelationCard
            v-for="node in otherPeople"
            :key="node.id"
            :nodeState="node.state"
            :firstName="node.firstName"
            :lastName="node.lastName"
            :sublabel="node.sublabel"
            :lastUpdate="node.lastUpdate"
            :type="node.civility"
            :completion="node.completion"
            :validationError="node.validationError"
            @click="selectCard(node.id)"
          />
        </v-row>
      </div>
    </div>
    <v-row
      class="d-flex flex-column pr-10 floating-cgu-btn"
      align="end"
      justify="space-around"
    >
      <v-btn
        text
        class="theme-btn nice-padding float-right"
        @click="cguDialog = true"
      >
        {{ $t('welcome.btn') }}
      </v-btn>
    </v-row>
    <v-row
      class="d-flex flex-column copyright"
      align="center"
      justify="center"
    >
      <div class="text">{{ $t('login.copy_right') }}</div>
      <v-img
        :src="'./assets/icons/WeSave-Conseil-logo-watermark@3x.svg'"
        class="logo-login"
        height="13"
        width="48"
      />
    </v-row>
  </div>
</template>

<script>
  import ApiService from '@/services/ApiService'
  import CommonMixin from '@/mixins/store/CommonMixin'
  import { NODE_STATES } from '@/components/common/RelationCard/RelationCard.const'
  import { PERSON_STATUS } from '@/services/models.const'

  import RelationCard from '@/components/common/RelationCard/RelationCard'
  import RightDrawer from '@/components/RightDrawer/RightDrawer'
  import AdvertisingModal from '@/components/ui/partials/AdvertisingModal/AdvertisingModal'
  import WeDialog from '@/components/ui/common/Dialog/Dialog'

  export default {
    name: 'Profile',
    components: {
      AdvertisingModal,
      RelationCard,
      RightDrawer,
      WeDialog,
    },
    mixins: [CommonMixin,],
    data() {
      return {
        currentNodeId: null,
        nodes: [],
        rightDrawerWidth: 788,
        hideAdvertisingModal: false,
        advertisingUrl: 'https://www.wesave.fr/',
        cguDialog: false,
        userConsent: null,
      }
    },
    computed: {
      vous() {
        return this.nodes.find((item) => item.type === 'owner')
      },
      otherPeople() {
        return this.nodes.filter((item) => item.type !== 'owner')
      },
      showAdvertising() {
        const fileStatus = this.currentUser.meta.customer_file_status
        const showAdvertising = fileStatus !== PERSON_STATUS.created && fileStatus !== PERSON_STATUS.pending

        return showAdvertising
      },
      showAdvertisingModal() {
        if (this.hideAdvertisingModal) {
          return false
        }

        return this.showAdvertising
      },
    },
    watch: {
      userConsent(val) {
        this.changeConsent(val)
      },
      selectedProfile() {
        this.createNodes()
      },
    },
    async mounted() {
      this.toggleAppLoader(true)
      this.userConsent = this.currentUser.user_consent
      const peopleDetails = await ApiService.getPeople(this.currentPeople)

      this.toggleAppLoader(false)
      this.$store.commit('profile/setPeopleDetails', peopleDetails)
      this.createNodes()
    },
    methods: {
      async changeConsent(val) {
        if (this.currentUser.user_consent !== val) {
          const result = await ApiService.updatePerson(this.currentUserId, {
            type: 'people',
            attributes: {
              user_consent: val,
            },
          })
          if (result.errors) {
            this.$message({
              type: 'error',
              text: 'update_infos_error',
            })
          } else {
            this.$store.commit('profile/updatePersonConsent', result)
            this.$message({
              type: 'success',
              text: 'update_infos_success',
            })
            this.cguDialog = false
          }
        }
      },
      createNodes() {
        this.toggleAppLoader(true)
        this.nodes = []
        const checks = this.currentUser.person_controls[0].checks
        const validationError = Object.values(checks).some((val) => !val && val !== null)
        this.nodes.push({
          state: 'normal',
          type: 'owner',
          id: this.currentUser.id,
          firstName: this.currentUser.first_name,
          lastName: this.currentUser.last_name,
          sublabel: this.$t(`main.roles.${this.currentUser.person_kind}`),
          lastUpdate: this.$d(new Date(this.currentUser.meta.updated_at), 'short'),
          civility: this.currentUser.civility || 'moral',
          completion: +this.currentUser.meta.completion_rate,
          validationError,
        })
        this.peopleDetails.forEach((item) => {
          const checks = item.person_controls[0].checks
          const validationError = Object.values(checks).some((val) => !val && val !== null)
          this.nodes.push({
            state: 'normal',
            type: item.person_kind,
            id: item.id,
            firstName: item.first_name,
            lastName: item.last_name,
            sublabel: this.$t(`main.roles.${item.person_kind}`),
            lastUpdate: this.$d(new Date(item.meta.updated_at), 'short'),
            civility: item.civility || 'moral',
            completion: +item.meta.completion_rate,
            validationError,
          })
        })
        this.updateCardsState()
        this.toggleAppLoader(false)
      },
      updateCardsState() {
        const currentNodeIndex = this.nodes.findIndex((item) => item.id === this.currentNodeId)
        if (currentNodeIndex >= 0) {
          this.nodes[currentNodeIndex].state = NODE_STATES.current
        }
      },
      async selectCard(id) {
        if (id === null) {
          this.$store.commit('profile/resetProfile')
          this.$store.commit('profile/selectProfile', id)

          return
        }
        this.$store.commit('profile/selectProfile', id)
        await this.refreshSelectedProfile(true)
        this.$store.commit('common/setConfigFields', this.selectedProfile.person_kind)
        this.currentNodeId = id
        if (this.currentNodeId) {
          this.$store.commit('profile/openDrawer')
        } else {
          this.$store.commit('profile/closeDrawer')
        }
      },
    },
  }
</script>

<style scoped lang="scss">
.Profile {
  height: 100%;
  padding: 40px;
  @media (max-width: 1000px) {
    padding: 20px 40px;
  }
  .header-title {
    font-size: 1.5rem;
    @media (max-width: 600px) {
      font-size: 1.2rem;
    }
    letter-spacing: 0.32px;
    color: $color-001c4b;
  }
  .NbPersons {
    color: $color-009ee0;
    display: inline;
  }
  .icn-help {
    display: inline-flex;
  }
  &_rightDrawer {
    box-shadow: 0 16px 32px 0 $color_31_54_139_12;
    position: fixed;
    background: $color_ffffff;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
  }
  .floating-cgu-btn {
    width: 100%;
    position: fixed;
    bottom: 4%;
    z-index: $zIndexCopyright;
    .theme-btn {
      color: $color_004f9f;
      box-shadow: unset;
      text-decoration: underline;
    }
  }
  .copyright {
    width: 100%;
    position: fixed;
    bottom: 2%;
    z-index: $zIndexCopyright;
    .text {
      color: $color-b4bad2;
      font-size: 0.8em;
      font-weight: 500;
      letter-spacing: 0.18px;
      line-height: 1em;
      text-align: center;
    }
  }
  .mainContent {
    position: relative;

    &_pub {
      position: absolute;
      right: 0;
      top: 0;

      &_image {
        width: 280px;
      }
    }
  }
}
.cgu {
  position: absolute;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  border: 1.4px solid rgba(121, 137, 183, 0.08);
  border-radius: 4px;
  background-color: $color-fafbff;
  .title {
    font-size: 1.3em;
    color: $color-202122;
    @media (max-width: 1025px) {
      font-size: 1rem;
      font-weight: 600;
      letter-spacing: 0;
    }
  }
  .description {
    color: $color-4d4d4f;
    font-size: 0.9em;
    font-weight: 500;
    letter-spacing: 0.21px;
    line-height: 1.4em;
  }
  /* stylelint-disable max-nesting-depth */
  .cguCheckbox {
    color: $color-000000 !important;
    font-size: 1.2em;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 2em;
  }
  .checkbox-dark {
    opacity: 0.4;

    label {
      color: $color-009ee0 !important;
      font-size: 16px;
      letter-spacing: 0.24px;
      line-height: 24px;
      margin-left: 1rem;
    }

    &.v-input--is-label-active {
      opacity: 1;
    }
  }
  .subDescription {
    color: $color-9e9fa2;
    font-size: 0.88em;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 1.2em;
  }
}
</style>
